<template>
  <div class="flex flex-col">
    <div class="flex flex-auto flex-col justify-center">
      <h1
        class="mb-4 text-balance font-title text-3xl/normal md:text-4xl/normal 3xl:text-5xl/snug"
        data-cy-contact-page-title
      >
        <slot name="title">
          {{ title }}
        </slot>
      </h1>

      <div v-if="subtitle || $slots.subtitle">
        <slot name="subtitle">
          <p v-if="subtitle" class="text-balance leading-loose">
            {{ subtitle }}
          </p>
        </slot>
      </div>

      <div v-if="$slots.default" class="md:mt-8 lg:mt-16">
        <slot />
      </div>
    </div>

    <div v-if="$slots.append" class="mt-6 hidden lg:block tall:hidden">
      <slot name="append" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

defineProps<{
  title?: I18nMessage;
  subtitle?: I18nMessage;
}>();
</script>
